import {
  Component,
  inject,
  OnInit,
  signal,
  WritableSignal,
} from '@angular/core';

import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { Router } from '@angular/router';

import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';

import {
  HEADER_CONFIG,
  HEADER_LOGO_CONFIG,
} from './configurations/header.config';

import { Header, Logo } from './models/backoffice-header.model';

import { HeaderNotificationsComponent } from './components/header-notifications/header-notifications.component';
import { HeaderUserComponent } from './components/header-user/header-user.component';
import { AuthContextService } from '@core/services/auth-context.service';
import { AppLoginMode } from '@core/configurations/auth.config';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    NgbDropdownModule,
    HeaderUserComponent,
    TranslatePipe,
    HeaderNotificationsComponent,
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  readonly headerLogoConfig: Logo = HEADER_LOGO_CONFIG;
  readonly gencatHeaderConfig: Header = HEADER_CONFIG;

  private readonly currentLanguageSignal: WritableSignal<string> =
    signal<string>('');

  private readonly _translateService = inject(TranslateService);
  private readonly _authContextService = inject(AuthContextService);
  private readonly _router = inject(Router);

  contextMode?: AppLoginMode;

  ngOnInit(): void {
    this.contextMode = this._authContextService.getMode();
    this.currentLanguageSignal.set(this._translateService.currentLang);
  }

  goHome(): void {
    this._router.navigateByUrl('/home');
  }
}
